export default {"src":"/_next/static/media/qr-code.e72effc8.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};